import {useRef} from 'react'
import {
  SActionBtn,
  SBack,
  SLowcodeList, SMessage,
  STableActions,
} from 'shj-components'
import { useSetState } from 'ahooks'
import SellModal from './components/SellModal';
import { config } from './config/index.tsx'
import styles from './index.module.less'
import {
  getGoodsSaleCategoryTreeList,
  goodsSaleCategoryDelete, goodsSaleCategoryUpdateState
} from "@/services/goods.ts";
import {message, Switch} from "antd";
import {DescModal} from "@/pages/sellManage/components/DescModal.tsx";

export default function PriceManage ()  {
  const [state, setState] = useSetState<any>({
      addOrEditModalOpen: false,
      cateTreeList: [],
      descEditModalOpen: false,
      record: {},
  })

  const listRef = useRef()

  //   右侧数据查询
  const fetchList = () => {
    return new Promise((resolve, reject) => {
      getGoodsSaleCategoryTreeList({searchFlag: true}).then(res=>{
        resolve({records: res})
        setState({cateTreeList: res})
      }).catch(reject)
    })
  }

  // 右侧表格事件：
  const onAdd = () => onEdit()

  const onEdit = (record = {}) => {
    setState({addOrEditModalOpen: true, record})
  }

  const handleCloseSellModal = () => {
    setState({addOrEditModalOpen: false, record: {}})
  }

  const onChangeStatus = (enabled: boolean, id: string)=>{
    SMessage.confirm({
      title: '修改状态',
      content: `是否确认${enabled ? '启用' : '禁用'}该数据`,
      onOk: () => {
        return goodsSaleCategoryUpdateState({idList: [id], enabled}).then((res: any) => {
          message.success(res.message || '操作成功');
          listRef.current?.reload()
        })
      },
    });
  }

  const onDel = (id: string) => {
    SMessage.confirm({
      onOk: () => {
        return goodsSaleCategoryDelete(id).then((res: any) => {
          message.success(res.message || '操作成功');
          listRef.current?.reload()
        })
      },
    });
  }

  const onEditDesc = (record) => {
    setState({descEditModalOpen: true, record})
  }

  // 右侧表格配置
  const extensions = {
    request: { fetchList },
    events: { onAdd },
    customRender: {
      switchRender(v: boolean, record: Record<string, any>) {
        return <Switch checkedChildren="启用" unCheckedChildren="禁用"
                       disabled={v && record.object?.initFlag}
                       checked={v} onClick={(checked) => onChangeStatus(checked, record.object.id)}/>
      },
      actionRender(_, record: Record<string, any>) {
        const level  = record.object?.cateIdPath?.split('>').length;
        return (
          <STableActions>
            <SActionBtn onClick={() => onEdit(record.object)}> 编辑 </SActionBtn>
            <SActionBtn onClick={() => onEditDesc(record.object)}> 类目介绍 </SActionBtn>
            {level - 1 < 3 && !record.object.initFlag && <SActionBtn onClick={() => onEdit({parentId: record.id})}> 添加下级 </SActionBtn>}
            {!record.object.initFlag && <SActionBtn danger onClick={() => onDel(record.id)}> 删除 </SActionBtn>}
          </STableActions>
        )
      },
    },
  }

  return (
    <div className={styles.settlementQuotaConfig}>
      <SBack title="销售类目"></SBack>
      <div className={styles.rightTable}>
        <SLowcodeList ref={listRef} searchMode="group" config={config} {...extensions} tableType={'antd'} />
      </div>
      <SellModal fn={listRef.current?.reload} {...state} onClose={handleCloseSellModal} />

      <DescModal {...state} fn={listRef.current?.reload} onClose={()=>setState({descEditModalOpen: false, record: {}})}/>
    </div>
  )
}